export class OnEnter implements ng.IDirective {
    restrict = 'A';
    scope: {

    };

    link: (scope: angular.IScope, element: angular.IAugmentedJQuery, attrs: angular.IAttributes) => any;

    constructor() {
        this.link = (scope: ng.IScope, element: ng.IAugmentedJQuery,
                     attrs: ng.IAttributes) => {
            const ENTER_KEY = 13;

            element.on('keyup', (ev) => {
                if (ev.keyCode === ENTER_KEY) {
                    scope.$eval(attrs['onEnter']);
                }
            });
        }
    }

    static factory(): ng.IDirectiveFactory {
        const directive = () => new OnEnter();
        directive.$inject = [];
        return directive;
    }
}